export interface ICheckStatus {
    EmailConfirmed?: boolean;
    HasPassword?: boolean;
    IsValid?: boolean;
    PhoneNumberConfirmed?: boolean;
}

export interface IConfirmEmail {
    Email: string;
    Code: string;
}

export enum AppSource {
  None = 0,
  Actuar = 1,
  Treino = 2,
  Afig = 3,
  FacilFit = 4,
  PagueLa = 5,
  Toletus = 6,
  CatracaParaAcademia = 7,
  Act = 8,
  Reserva = 9,
  Ediz = 10,
}